export default "__VITE_ASSET__D$TLviO9__"